import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { formatDate } from "utils/Utils";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { stateTableColumns } from "assets/properties/properties";

const StateMaster = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const { stateData }=useSelector((state)=>state.masterstate);

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_STATE_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.error_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  }
  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
    data.forEach((state, index) => {
        let row = {
          code: state.code,
          name: state.name,
          gst: state.gstNumber,
          gstCode: state.gstCode,
          cgst: state.cgstPercentage,
          sgst: state.sgstPercentage,
          igst: state.igstPercentage,
          language: state.language,
          action: getIcons(state.code),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  // icons function
  const getIcons = (code) => {
    return (
      <>
        <IconButton
          aria-label="Edit State"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (code) => {
    navigate(`/coreservice/state-create/` + code);
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        ( row?.name?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.gstNumber?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.code?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.language?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.gstCode?.toLowerCase()?.includes(val?.toLowerCase()) )
      );
    });
    parseIndicatorData(filteredData);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="State"
          onSearchChange={onSearchChange}
          searchLabel="Search For State"
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={stateTableColumns} rows={selectedTableData} />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </GridContainer>
  );
};

StateMaster.propTypes = {
  classes: PropTypes.object,
};

export default StateMaster;
